import React, { FC, useRef } from 'react';

import {
  Container,
  Image,
  useClickOutside,
  ContainerProps,
} from '@lglp/components';
import { MainMenuItem } from '@lglp/prismic-client';

import { RichText } from '../../../RichText';
import { useDesktopContext } from './DesktopContext';
import styles from './MenuContent.module.scss';
import { SubmenuItemList } from './Submenu';

export const MenuContent: FC<MenuContentProps> = ({ menuItem }) => {
  const { openedMenus, close } = useDesktopContext();
  const menuContentRef = useRef();

  useClickOutside(
    () => {
      close();
    },
    menuContentRef,
    ['click']
  );

  return (
    <Container innerRef={menuContentRef} className={styles.menuContainer}>
      <Container className={styles.menuDescription}>
        <span className={styles.label}>{menuItem.label}</span>
        <RichText body={menuItem.description} />
      </Container>
      <SubmenuItemList
        level={0}
        className={[styles.submenu, styles.firstSubmenu]}
      />
      <SubmenuItemList level={1} className={styles.submenu} />
      {openedMenus[2] ? (
        <SubmenuItemList level={2} className={styles.submenu} />
      ) : (
        <Image
          fit={true}
          src={menuItem.image.src}
          alt={menuItem.image.alt}
          className={styles.picture}
        />
      )}
    </Container>
  );
};

type MenuContentProps = ContainerProps & { menuItem: MainMenuItem };
